import { Link } from 'react-router-dom';
import { categories } from '@/mocks/sports';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h4 className="font-heading text-xl font-bold mb-4">
                <Link to="/" className="cursor-pointer hover:text-accent-500 transition-colors">米乐体育</Link>
              </h4>
              <p className="text-sm text-background-50/60 leading-relaxed">
                米乐体育是专业体育赛事平台，汇聚全球顶级赛事直播、体育竞技、数据分析与互动娱乐。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold mb-4 text-background-50/80">赛事分类</h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-50/50 hover:text-accent-500 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold mb-4 text-background-50/80">快速链接</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-background-50/50 hover:text-accent-500 transition-colors cursor-pointer">首页</Link>
                </li>
                <li>
                  <Link to="/category/football" className="text-sm text-background-50/50 hover:text-accent-500 transition-colors cursor-pointer">足球赛事</Link>
                </li>
                <li>
                  <Link to="/category/basketball" className="text-sm text-background-50/50 hover:text-accent-500 transition-colors cursor-pointer">篮球赛事</Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-50/50 hover:text-accent-500 transition-colors cursor-pointer">关于我们</Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold mb-4 text-background-50/80">联系我们</h4>
              <ul className="space-y-2.5 text-sm text-background-50/50">
                <li className="flex items-center gap-2">
                  <i className="ri-phone-line text-accent-500 w-4 h-4 flex items-center justify-center"></i>
                  <span>400-888-6666</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line text-accent-500 w-4 h-4 flex items-center justify-center"></i>
                  <span>service@milesports.com</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-map-pin-line text-accent-500 w-4 h-4 flex items-center justify-center"></i>
                  <span>北京市朝阳区建国路88号</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-50/30">
              &copy; 2026 米乐体育 MileSports. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-50/30 hover:text-accent-500 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-background-50/30 hover:text-accent-500 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
              <a href="#" className="text-xs text-background-50/30 hover:text-accent-500 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}